import { gql } from "lib/apolloClient";
import { processJournalFragment } from "./Fragments";

export const getProcessJournalListQuery = gql`
  query getProcessJournalList(
    $id: ID!
    $filters: PostFilterInput
    $after: String
  ) {
    node(id: $id, type: PROJECT) {
      id
      ... on Project {
        id
        projectComments(filters: { projectCommentType: PROJECT_EVIDENCE }) {
          totalCount
        }
        notificationBadgeCounts {
          unreadProjectEvidenceCommentCount
        }
        posts(filters: $filters, after: $after, last: 6) {
          totalCount
          edges {
            node {
              ...processJournalItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${processJournalFragment.basicDetails}
`;

export const getPlannerElementEvidencesQuery = gql`
  query getPlannerElementEvidences(
    $id: ID!
    $plannerElementEvidenceFilters: PlannerElementsEvidenceFilter!
  ) {
    node(id: $id, type: STUDENT_PROJECT_PORTFOLIO) {
      ... on StudentProjectPortfolio {
        id
        posts(filters: $plannerElementEvidenceFilters) {
          edges {
            node {
              ...processJournalItem
              ... on Post {
                items(filters: { itemType: [PROJECT] }) {
                  itemType
                  item {
                    ... on Project {
                      id
                      title {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${processJournalFragment.basicDetails}
`;
